import { Query } from '../../_base/actionBus/Query';
import { Manager } from '../../models/managers/Manager';

export class GetUnitManager extends Query<Manager>{}
